import type { Messages } from './en';

export const es: Messages = {
  nav: {
    home: 'Inicio',
    work: 'Trabajo',
    about: 'Acerca de',
    contact: 'Contacto',
    logoHome: 'Inicio',
  },
  language: {
    label: 'Idioma',
    en: 'EN',
    es: 'ES',
    switchTo: 'Cambiar a {language}',
  },
  theme: {
    groupLabel: 'Tema de color',
    light: 'Claro',
    system: 'Sistema',
    dark: 'Oscuro',
    optionTitle: 'Tema {label}',
    cycleTitle: 'Tema: {current}. Cambiar a {next}.',
    cycleHidden: 'Tema de color: {current}. Cambiar a {next}.',
  },
  meta: {
    role: 'Ingeniero de software',
    homeDescription:
      'David Martínez — Ingeniero de software. Sistemas escalables, rendimiento y entrega confiable.',
    aboutDescription:
      'Ingeniero de software con más de 8 años diseñando y operando sistemas escalables y de alta disponibilidad.',
    workDescription: 'Casos de estudio y sistemas seleccionados — problema, enfoque y resultado.',
    contactDescription: 'Para roles, colaboraciones o conversaciones técnicas.',
  },
  home: {
    title: 'Diseño y construyo sistemas de software escalables y tolerantes a fallos.',
    subheadline:
      'Ingeniero de software con más de 8 años lanzando plataformas backend, servicios distribuidos y rutas críticas de rendimiento — con un enfoque pragmático en confiabilidad, mantenibilidad y resultados medibles.',
    metrics: {
      queries: 'Consultas más rápidas',
      stability: 'Estabilidad operativa',
      reliability: 'Confiabilidad en producción',
      coverage: 'Cobertura de tests',
      context: '*Resultados de trabajo reciente en plataforma y rendimiento',
    },
    focusAreas: 'Áreas de enfoque',
    selectedWork: 'Trabajo seleccionado',
    viewWork: 'Ver trabajo',
    services: [
      {
        id: 'backend',
        title: 'Backend y sistemas distribuidos',
        description:
          'Rails, Node/NestJS, microservicios y arquitecturas orientadas a eventos, pensadas para escala y claridad.',
      },
      {
        id: 'performance',
        title: 'Rendimiento y resiliencia',
        description:
          'Optimización de consultas, workers asíncronos, colas y caché ajustados a carga real de producción.',
      },
      {
        id: 'observability',
        title: 'Observabilidad y calidad',
        description:
          'Mejor monitoreo, más confiabilidad en producción, SOLID/TDD y bases de código más sanas.',
      },
      {
        id: 'ai',
        title: 'Ingeniería asistida por IA',
        description:
          'Agentes, MCP y flujos de trabajo que suben el throughput del equipo sin bajar el listón de ingeniería.',
      },
    ],
  },
  about: {
    title: 'Acerca de',
    subtitleLine1: 'Construir sistemas confiables,',
    subtitleLine2: 'y las prácticas que los sostienen.',
    profileTitle: 'Ingeniero de software',
    p1:
      'Ingeniero de software con más de 8 años diseñando, desarrollando y operando sistemas escalables y de alta disponibilidad. Me importan la arquitectura clara, los trade-offs pragmáticos y entregar software que aguante en producción — no solo en demos.',
    p2:
      'En Rankmi me enfoqué en rendimiento y plataforma: hacer las consultas drásticamente más rápidas, subir la estabilidad operativa con procesamiento asíncrono y liderar un microservicio de notificaciones que la organización estandarizó. Antes, en Asymm, llevé features de punta a punta y subí la calidad con más cobertura y menos deuda técnica. Últimamente también he profundizado en desarrollo asistido por IA, agentes y MCP para acelerar flujos de ingeniería.',
    expertise: 'Experiencia técnica',
    skills: [
      {
        category: 'Backend y arquitectura',
        items: [
          'Ruby on Rails',
          'Node.js',
          'NestJS',
          'REST APIs',
          'GraphQL',
          'Microservices',
          'Arquitectura orientada a eventos',
        ],
      },
      {
        category: 'Bases de datos',
        items: ['PostgreSQL', 'MongoDB', 'Redis', 'Modelado de datos', 'Optimización de consultas'],
      },
      {
        category: 'Front-End',
        items: ['React', 'TypeScript', 'JavaScript (ES6+)', 'Redux', 'React Native'],
      },
      {
        category: 'Cloud y DevOps',
        items: ['AWS', 'GCP', 'Docker', 'Kubernetes', 'CI/CD'],
      },
      {
        category: 'Rendimiento y observabilidad',
        items: ['Procesamiento asíncrono', 'Colas de mensajes', 'Caché', 'New Relic', 'Datadog', 'Sentry'],
      },
      {
        category: 'Ingeniería de IA',
        items: ['Desarrollo asistido por IA', 'Agentes de IA', 'MCP', 'Flujos agénticos'],
      },
      {
        category: 'Prácticas de ingeniería',
        items: ['System Design', 'SOLID', 'Patrones de diseño', 'TDD', 'Liderazgo técnico'],
      },
    ],
  },
  work: {
    title: 'Trabajo',
    subtitle: 'Casos de estudio',
    viewCaseStudy: 'Ver caso de estudio',
    more: 'más',
    problem: 'Problema:',
    solution: 'Solución:',
    result: 'Resultado:',
    fallbacks: {
      problem: 'Reto técnico que pedía una arquitectura escalable.',
      solution: 'Arquitectura moderna, con ownership claro y confiabilidad.',
      result: 'Mejor rendimiento y confiabilidad.',
    },
  },
  contact: {
    title: 'Contacto',
    subtitle: 'Para roles, colaboraciones o conversaciones técnicas.',
    sendEmail: 'Escríbeme a',
  },
  project: {
    back: 'Volver a proyectos',
    previous: 'Proyecto anterior',
    next: 'Proyecto siguiente',
  },
  cta: {
    getInTouch: 'Contactar',
    interested: '¿Te interesa? ¿Tienes alguna pregunta?',
    openTo:
      'Abierto a colaboración de ingeniería y roles donde el diseño de sistemas y la calidad de entrega importan.',
  },
  notFound: {
    title: 'Página no encontrada',
    goHome: 'Ir al inicio →',
  },
};
